import React, { useState, useEffect, useCallback, useRef, createRef } from 'react';
import { icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import SafetyRow from '../Safety/SafetyRow';
import SafetyRowPlaceholder from '../Safety/SafetyRowPlaceholder';
import NewButton from '../Buttons/NewButton';
import { useIsMobile } from '../../helpers/customHooks';
import { useSidebarContext } from '../Sidebar/SiderbarContext';    
import SafetyModal from '../Modals/SafetyModal';
import axios from 'axios';
import { useContextData } from '../ContextData';

const SecurityView = ({ show }) => {
    const { t } = useTranslation();
    const MOBILE = useIsMobile();
    const navigate = useNavigate();
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [historyList, setHistoryList] = useState([]);
    const [loading, setLoading] = useState(true)
    const listInnerRef = createRef();
    const sentinelRef = useRef(null);
    const [type, setType] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [showButtons, setShowButtons] = useState(false)
    const hasMore = totalPages === -1 ? true : currentPage < totalPages;
    const { setActionbarContent, topbarContent, setTopbarContent, topbarTwoContent, setTopbarTwoContent } = useSidebarContext();
    const { setAccessToken, setDeviceListMap, setDeviceListCompact } = useContextData();

    const openModal = (type) => {
        setType(type)
        setShowModal(!showModal)
    }
    
    useEffect(() => {
        if(show){
            getLoginHistory()
        }
    }, [show])


    useEffect(() => {
        if(show){
            const topcontent = {
                right: (
                    <div className="cursor-pointer round-bg bg-white menu-button d-flex align-items-center justify-content-center" onClick={() => setShowButtons(!showButtons)}>
                        <img key="settings" src={icons.dots_vertical} alt="settings" className="size_15 primary-icon" initial={{ opacity: 1, rotate: 90 }} animate={{ opacity: 1, rotate: 0 }} exit={{ opacity: 1, rotate: 180 }} transition={{ duration: 0.2 }} />
                    </div>
                )
            }
            if(MOBILE){
                setTopbarContent({...topbarContent, ...topcontent});
            }else{
                setTopbarTwoContent({...topbarTwoContent, ...topcontent})
            }
        }else{
            setHistoryList([])
            setShowButtons(false)
            const topcontent = { right: null }
            const topTwoContent = { right: null }
            setTopbarContent({...topbarContent, ...topcontent});
            setTopbarTwoContent({...topbarTwoContent, ...topTwoContent})
        }
    }, [show, showButtons])

    useEffect(() => {
        if(!show){
                const topTwoContent = {
                    right: null,
                    action: null
                }
            setActionbarContent(null)
            setTopbarTwoContent({...topbarTwoContent, ...topTwoContent})
            return;
        };
        if(showButtons){
            if(MOBILE){
                const actioncontent = (
                    <div key="menu" className="flex-grow-1 position-relative zlatan m-3">
                        {/* Scrollable content inside the glass nav */}
                        <div className="h-100 overflow-auto">
                            <div className="d-flex flex-column">
                                <NewButton className="bg-grey-blue white rounded24 w-100 bold mb-2 p-3" onClick={() => openModal("clear")}>{t("settings.clear_history")}</NewButton>
                                <NewButton className="bg-red white-white rounded24 w-100 bold p-3" onClick={() => openModal("logout")} btnClass="btn-danger ms-2">{t("settings.logout_all_sessions")}</NewButton>
                            </div>
                        </div>
                    </div>
                )
                setActionbarContent(actioncontent)
            }else{
                const topTwoContent = {
                    right: (
                    <div className="cursor-pointer round-bg bg-white menu-button d-flex align-items-center justify-content-center" onClick={() => setShowButtons(!showButtons)}>
                        <img key="settings" src={icons.dots_vertical} alt="settings" className="size_15 primary-icon" initial={{ opacity: 1, rotate: 90 }} animate={{ opacity: 1, rotate: 0 }} exit={{ opacity: 1, rotate: 180 }} transition={{ duration: 0.2 }} />
                    </div>  
                    ),
                    action: (
                        <div key="menu" className="flex-grow-1 position-relative zlatan m-3">
                        {/* Scrollable content inside the glass nav */}
                        <div className="h-100 overflow-auto">
                            <div className="d-flex flex-column">
                                <NewButton className="bg-grey-blue white rounded24 w-100 bold mb-2 p-3" onClick={() => openModal("clear")}>{t("settings.clear_history")}</NewButton>
                                <NewButton className="bg-red white-white rounded24 w-100 bold p-3" onClick={() => openModal("logout")} btnClass="btn-danger ms-2">{t("settings.logout_all_sessions")}</NewButton>
                            </div>
                        </div>
                    </div>
                    )           
                }
                setTopbarTwoContent({...topbarTwoContent, ...topTwoContent})
            }
        }else{
            if(!MOBILE){
                const topTwoContent = {
                    right: (
                        <div className="cursor-pointer round-bg bg-white menu-button d-flex align-items-center justify-content-center" onClick={() => setShowButtons(!showButtons)}>
                            <img key="settings" src={icons.dots_vertical} alt="settings" className="size_15 primary-icon" initial={{ opacity: 1, rotate: 90 }} animate={{ opacity: 1, rotate: 0 }} exit={{ opacity: 1, rotate: 180 }} transition={{ duration: 0.2 }} />
                        </div>
                    ),
                    action: null
                }
                // const topTwoContent = { action: null, right: null}
                setTopbarTwoContent({...topbarTwoContent, ...topTwoContent})
            }else{
                setActionbarContent(null)
            }
        }
    }, [showButtons, show])

    const getLoginHistory = (page = currentPage) => {
        let data = {
            page: page,
            limit: 100
        }
        let url;
        if(process.env.REACT_APP_FLAVOR === "bike" || process.env.REACT_APP_FLAVOR === "alco"){
            url = "login/history"
        }else{
            url = "login/history"

        }
        request.post("", url, data).then((response) => {
            if(response.status === 200){
                setLoading(false)
                setHistoryList(historyList => [...historyList, ...response.data.data])
                setTotalPages(response.data.totalPages)
            }else{
                setLoading(false)
            }
        })
    }

        const clearHistory = () => {
        let ids = historyList.map((history) => history.id);
        let data = {
            loginid: ids,
            deleteAll: true
        }
        request.post("", "login/delete", data).then((response) => {
            if(response.data){
                setHistoryList([])
                setShowModal(false)
                getLoginHistory()
                toast.success(t("toast.success"))

            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }

    const logoutAll = () => {
        let cancelTokenSource = axios.CancelToken.source();
        // Function to cancel all ongoing requests
        const cancelOngoingRequests = () => {
            cancelTokenSource.cancel('Logout initiated: Cancelling all ongoing requests.');
            // Create a new CancelToken source for future requests
            cancelTokenSource = axios.CancelToken.source();
        };
        request.get("login/signOutAll").then((response) => {
            if(response.data){
                cancelOngoingRequests(); // Cancel ongoing requests
                localStorage.clear()
                setAccessToken(null)
                setDeviceListMap([])
                setDeviceListCompact([])
                navigate("/devices")
            }
        })
    }

    const loadMore = useCallback(() => {
        if (loading) return;
        if (!hasMore) return;

        setLoading(true);

        const next = currentPage + 1;
        getLoginHistory(currentPage + 1)
        setCurrentPage(next);
    }, [loading, hasMore, currentPage]);

    const onScroll = useCallback(() => {
        // const el = listInnerRef.current;
        // if (!el || loading ) return;
        // const { scrollTop, scrollHeight, clientHeight } = el;
        // if (scrollTop + clientHeight >= scrollHeight - 2) {
        //     loadMore();
        // }
    }, [loading, loadMore]);

    useEffect(() => {
        // if(!MOBILE) return;
        // const rootEl = !MOBILE ? listInnerRef.current : null;
        const rootEl = null;

        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    loadMore();
                }
            },
            {
                root: rootEl, // null = viewport (mobile)
                rootMargin: "200px",
                threshold: 0,
            }
        );

        if (sentinelRef.current) observer.observe(sentinelRef.current);
        return () => observer.disconnect();
    }, [MOBILE, loadMore]);

    if(!show) return;

    return(
    <>
    {/* <p className="thin">{t("settings.safety")}</p> */}
    <p className="mb-1 bold">{t("settings.login_history")}</p>
        <div ref={listInnerRef} onScroll={() => onScroll()} className="d-flex rounded24 flex-column">
            {loading &&
            <SafetyRowPlaceholder />
            }
            <div className="settings-radius bg-white rounded24">
            {historyList && historyList.map((history, index) => (
                    <SafetyRow key={index} history={history} index={index} totes={historyList?.length - 1} />
            ))}
            <div ref={sentinelRef} style={{ height: 1 }} />
            </div>
        </div>
        {historyList && historyList.length === 0  && !loading &&
            <div className="p-3 w-100">
                <h3 className="regular text-center">{t("settings.no_history")}</h3>
            </div>
        }
        <SafetyModal show={showModal} clearHistory={() => clearHistory()} logoutAll={() => logoutAll()} type={type} onClose={() => setShowModal(!showModal)} />

        </>
    )
}

export default SecurityView;